import {css} from "@panda/css";

import {HOME_MATCH_PREFERENCES_SURVEY_COMPLETION_DATES} from "../../../constants/preferences/home_match_preferences_survey_content";
import {ConstructionEndDateType} from "../../../types/ConstructionEndDateType";
import {HomeMatchPreferencesSurveyPill} from "../HomeMatchPreferencesSurveyPill";

interface IProps {
    centered?: boolean;
    onChange: (value: ConstructionEndDateType | null) => void;
    value: ConstructionEndDateType | null;
}

export const HomeMatchPreferencesSurveyCompletionDatePills = (props: IProps) => {
    const {centered, onChange, value} = props;

    return (
        <div className={centered ? centeredStyle : rowStyle}>
            {HOME_MATCH_PREFERENCES_SURVEY_COMPLETION_DATES.map((option) => (
                <HomeMatchPreferencesSurveyPill
                    isSelected={value === option.value}
                    key={option.value}
                    label={option.label}
                    onSelect={() => onChange(value === option.value ? null : option.value)}
                />
            ))}
        </div>
    );
};

const rowStyle = css({
    display: "flex",
    flexWrap: "wrap",
    gap: 1
});

const centeredStyle = css({
    display: "flex",
    flexWrap: "wrap",
    gap: 1,
    justifyContent: "center"
});
import {css} from "@panda/css";

import {HOME_MATCH_PREFERENCES_SURVEY_COMPLETION_DATES} from "../../../constants/preferences/home_match_preferences_survey_content";
import {ConstructionEndDateType} from "../../../types/ConstructionEndDateType";
import {HomeMatchPreferencesSurveyPill} from "../HomeMatchPreferencesSurveyPill";

interface IProps {
    centered?: boolean;
    onChange: (value: ConstructionEndDateType | null) => void;
    value: ConstructionEndDateType | null;
}

export const HomeMatchPreferencesSurveyCompletionDatePills = (props: IProps) => {
    const {centered, onChange, value} = props;

    return (
        <div className={centered ? centeredStyle : rowStyle}>
            {HOME_MATCH_PREFERENCES_SURVEY_COMPLETION_DATES.map((option) => (
                <HomeMatchPreferencesSurveyPill
                    isSelected={value === option.value}
                    key={option.value}
                    label={option.label}
                    onSelect={() => onChange(value === option.value ? null : option.value)}
                />
            ))}
        </div>
    );
};

const rowStyle = css({
    display: "flex",
    flexWrap: "wrap",
    gap: 1
});

const centeredStyle = css({
    display: "flex",
    flexWrap: "wrap",
    gap: 1,
    justifyContent: "center"
});
